export const isPhoneRefusal = (failure) =>
  failure?.code === "entries_invalid" &&
  Boolean(failure.attributes?.includes("phone"))
